<template>
<div class="card" style="border-width: 0px">
    <div class="card-header px-0" style="background-color: #f4f5fa">
        {{ $t("user.header") }}
    </div>
    <div class="card-body px-0" style="background-color: #f4f5fa">
        <b-card :title="$t(`user.card_user`)" class="mb-3 shadow">
            <b-button v-b-toggle.help_user pill size="sm" variant="outline-secondary" class="info-button"><em>i</em></b-button>
            <b-button class="button-margin" variant="primary" to="/app/user/new"><b-icon icon="person-plus" />{{ $t("user.btn_usernew") }}</b-button>
            <b-button class="button-margin" variant="outline-primary" @click.prevent="showImport">
                <b-iconstack>
                    <b-icon stacked icon="person"></b-icon>
                    <b-icon stacked icon="arrow-down" shift-h="7" shift-v="3" scale="0.7"></b-icon>
                </b-iconstack>
                {{ $t("user.btn_userimport") }}
            </b-button>
            <b-sidebar right id="help_user" :title="$t(`help.info`)" backdrop-variant="dark" backdrop shadow width="600px" max-width="100%">
                <div class="px-3 py-2">
                    <b-list-group>
                        <b-list-group-item class="user-select-all">{{ $t("help.user_1") }}</b-list-group-item>
                        <b-list-group-item class="user-select-all">{{ $t("help.user_2") }}</b-list-group-item>
                        <b-list-group-item class="user-select-all">{{ $t("help.user_3") }}</b-list-group-item>
                        <b-list-group-item class="user-select-all">{{ $t("help.user_4") }}</b-list-group-item>                        
                    </b-list-group>
                </div>
            </b-sidebar>
            
            <br />
            <b-form-group horizontal :label="$t(`user.search`)" class="mb-0">
            <b-input-group>
                <b-form-input v-model="searchFilter" :placeholder="$t(`user.placeholder_search`)" />
                <b-input-group-append>
                <b-button :disabled="!searchFilter" @click="searchFilter = ''">{{ $t("user.btn_erase") }}</b-button>
                </b-input-group-append>
            </b-input-group>
            </b-form-group>
            <br />
            <div class="table-scrollable">
            <b-table striped hover :items="users" :fields="fields" :filter="searchFilter">
                <template #cell(accepted_terms_of_service)="data">
                    <template v-if="data.item.accepted_terms_of_service === true">{{ $t("user.tos_accepted") }}</template>
                    <template v-if="data.item.accepted_terms_of_service === false">{{ $t("user.tos_not_accepted") }}</template>
                </template>
                <template #cell(proof_of_entrepreneurial_status)="data">
                    <template v-if="data.item.proof_of_entrepreneurial_status === true">ok</template>
                    <template v-if="data.item.proof_of_entrepreneurial_status === false">ausstehend</template>
                </template>
                <template #cell(accepted_code_of_conduct)="data" v-if="role === Lieferant">
                    <template v-if="data.item.accepted_terms_of_service === true && data.item.accepted_code_of_conduct === true"><b-icon icon="check-square-fill" scale="1.5" variant="success"></b-icon></template>
                    <template v-if="data.item.accepted_terms_of_service === true && data.item.accepted_code_of_conduct === null"><b-icon icon="question-diamond" scale="1.5" variant="info"></b-icon></template>
                    <template v-if="data.item.accepted_terms_of_service === true && data.item.accepted_code_of_conduct === false"><b-icon icon="x-circle" scale="1.5" variant="danger"></b-icon></template>
                </template>
                <template #cell(score)="data">
                    <template>
                    </template>
                </template>
                <template #cell(actions)="data">
                    <b-link class="m-1" href="#" :to="'/app/user/edit/' + data.item.id" ><b-icon icon="pencil-square" scale="1.2"></b-icon></b-link>
                    <b-link class="m-1" href="#"  @click.prevent="requestConfirmation(data.item)"><b-icon icon="trash" scale="1.2"></b-icon></b-link>
                </template>
                <template #cell(show_details)="row">
                    <b-icon icon="chat-left-text" v-model="row.detailsShowing" v-if="row.item.notes" @click="row.toggleDetails"></b-icon>
                </template>
                  <template #row-details="row">
                    <b-card>
                        <p>Bemerkungen:</p>
                        <b-text class="mb-2" v-html="newlineToBr(row.item.notes)">
                        </b-text>
                    </b-card>
                  </template>
            </b-table>
            </div>
            <b-button class="button-margin" variant="primary" to="/app/user/new"><b-icon icon="person-plus" />{{ $t("user.btn_usernew") }}</b-button>
            <b-button class="button-margin" variant="outline-primary" @click.prevent="showImport">
                <b-iconstack>
                    <b-icon stacked icon="person"></b-icon>
                    <b-icon stacked icon="arrow-down" shift-h="7" shift-v="3" scale="0.7"></b-icon>
                </b-iconstack>
                {{ $t("user.btn_userimport") }}
            </b-button>
        </b-card>
    </div>
    <b-modal ref="confirmationModal" hide-footer :title="$t(`user.modal_userdelete`)">
        <div class="d-block text-center">
            <p v-if="userContext">{{ $t("user.userdelete_text1") }}<strong>'{{userContext.name}}'</strong>{{ $t("user.userdelete_text2") }}</p>
        </div>
        <b-button class="button-margin mt-3" variant="outline-danger" block @click="executeDelete">{{ $t("user.btn_delete") }}</b-button>
    </b-modal>
    <b-modal ref="importModal" hide-footer :title="$t(`user.modal_userimport`)">
        <div class="d-block text-center">
            {{ $t("user.modal_userimport_notes") }}
        </div>
        <b-form-file ref="excelFileInput" v-model="excelFile" :state="Boolean(excelFile)" :placeholder="$t(`user.placeholder_file`)"></b-form-file>
        <b-button class="button-margin mt-3" block @click="importExcelFile">{{ $t("user.btn_import") }}</b-button>
    </b-modal>
</div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import importService from '../../../../services/ImportService';

export default {
    name: 'user-list',
    data() {
        return {
            searchFilter: '',
            userContext: null,
            excelFile: null,
        }
    },
    created() {
        this.listUsers();
    },
    watch: {
        '$route': 'listUsers'
    },
    methods: {
        ...mapActions({
            listUsers: 'users/fetchUsers',
            deleteUser: 'users/delete'
        }),
        requestConfirmation(user) {
            this.userContext = user;
            this.$refs.confirmationModal.show();
            this.$refs.excelFileInput.reset();
        },
        executeDelete() {
            this.$refs.confirmationModal.hide();
            this.deleteUser(this.userContext.id)
                .then(data => {
                    this.$notify({
                        group: 'global',
                        title: this.$t("user.notifiy_deleteuser_title"),
                        type: 'success',
                        text: this.$t("user.notifiy_deleteuser_message"),
                    });

                    this.userContext = null;
                });
        },
        showImport() {
            this.excelFile = null;
            this.$refs.importModal.show();
        },
        newlineToBr: function (value) {
                return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
            },
        importExcelFile() {
            importService.importUser(this.excelFile)
                .then(response => {
                    if(response.data.success) {
                        this.$refs.importModal.hide();
                        this.$notify({
                            group: 'global',
                            title: this.$t("user.notifiy_importuser_title"),
                            type: 'success',
                            text: this.$t("user.notifiy_importuser_message"),
                        });

                        this.listUsers();
                    }else {
                        this.$refs.importModal.hide();
                        this.$notify({
                            group: 'global',
                            title: this.$t("user.notifiy_importuser_error"),
                            type: 'error',
                            text: response.data.message
                        });
                        this.listUsers();
                    }
                })
                .catch(error => {

                })
        }
    },
    computed: {
        ...mapGetters({
            users: 'users/users'
        }),
        fields() {
            return [
                {
                    key: 'id',
                    label: this.$t(`user.label_id`),
                },
                {
                    key: 'show_details',
                    label: this.$t(`user.label_notes`)
                },
                {
                    key: 'name',
                    label: this.$t(`user.label_username`),
                    sortable: true
                },
                {
                    key: 'company',
                    label: this.$t(`user.label_company`),
                    sortable: true
                },
                {
                    key: 'email',
                    label: this.$t(`user.email`),
                    sortable: true
                },
                {
                    key: 'sector.sector_name_' + this.$i18n.locale,
                    label: this.$t(`user.sector_name`),
                    sortable: true
                },
                {
                    key: 'created_at',
                    label: "Erstellt am",
                    sortable: true,
                    formatter: (value) => {
                        if (!value) return '';
                        return new Date(value).toISOString().slice(0, 10); 
                    }
                },
                {
                    key: 'accepted_terms_of_service',
                    label: this.$t(`user.label_accountactivation`),
                    sortable: true
                },
                {
                    key: 'proof_of_entrepreneurial_status',
                    label: this.$t(`user.proof_of_entrepreneurial_status_header`),
                    sortable: true
                },
                {
                    key: 'employee_count',
                    label: this.$t(`user.employees`),
                    sortable: true
                },
                {
                    key: 'accepted_code_of_conduct',
                    label: this.$t(`user.accepted_code_of_conduct_header`),
                    sortable: true
                },
                {
                    key: 'code_of_conduct',
                    label: this.$t(`user.accepted_code_of_conduct_header2`),
                    sortable: true
                },
                {
                    key: 'score',
                    label: 'Score',
                    sortable: true
                },
                {
                    key: 'role.name',
                    label: this.$t(`user.label_role`)
                },
                {
                    key: 'lksg_scope',
                    label: this.$t(`user.lksg_scope`),
                    sortable: true
                },
                {
                    key: 'actions',
                    label: this.$t(`user.label_actions`)
                }
            ];
        }

    }
};
</script>
